import { colorSchemes } from '@nivo/colors';

const preview = (key) => {
  const colorScheme = colorSchemes[key] ?? [];
  const colors = Array.isArray(colorScheme?.[colorScheme.length - 1])
    ? colorScheme[colorScheme.length - 1] : colorScheme;
  return (
    <div style={{
      width: '100px', height: '15px', display: 'flex', flexDirection: 'row',
    }}
    >
      {colors.map((color) => (
        <div
          key={`${key}_${color}`}
          style={{
            flex: '1', height: '100%', backgroundColor: color,
          }}
        />
      ))}
    </div>
  );
};

export const getOptionsThemes = () => ([
  {
    label: 'Padrão', value: 'nivo', id: 'nivo', icon: () => preview('nivo'),
  },
  {
    label: 'Distintas', value: 'category10', id: 'category10', icon: () => preview('category10'),
  },
  {
    label: 'Destaque', value: 'accent', id: 'accent', icon: () => preview('accent'),
  },
  {
    label: 'Escuras', value: 'dark2', id: 'dark2', icon: () => preview('dark2'),
  },
  {
    label: 'Emparelhadas', value: 'paired', id: 'paired', icon: () => preview('paired'),
  },
  {
    label: 'Pastel 1', value: 'pastel1', id: 'pastel1', icon: () => preview('pastel1'),
  },
  {
    label: 'Pastel 2', value: 'pastel2', id: 'pastel2', icon: () => preview('pastel2'),
  },
  {
    label: 'Grupo 1', value: 'set1', id: 'set1', icon: () => preview('set1'),
  },
  {
    label: 'Grupo 2', value: 'set2', id: 'set2', icon: () => preview('set2'),
  },
  {
    label: 'Grupo 3', value: 'set3', id: 'set3', icon: () => preview('set3'),
  },
  {
    label: 'Spectral', value: 'spectral', id: 'spectral', icon: () => preview('spectral'),
  },
  {
    label: 'Marrom → Verde', value: 'brown_blueGreen', id: 'brown_blueGreen', icon: () => preview('brown_blueGreen'),
  },
  {
    label: 'Roxo → Verde', value: 'purpleRed_green', id: 'purpleRed_green', icon: () => preview('purpleRed_green'),
  },
  {
    label: 'Rosa → Verde', value: 'pink_yellowGreen', id: 'pink_yellowGreen', icon: () => preview('pink_yellowGreen'),
  },
  {
    label: 'Roxo → Laranja', value: 'purple_orange', id: 'purple_orange', icon: () => preview('purple_orange'),
  },
  {
    label: 'Vermelho → Azul', value: 'red_blue', id: 'red_blue', icon: () => preview('red_blue'),
  },
  {
    label: 'Vermelho → Cinza', value: 'red_grey', id: 'red_grey', icon: () => preview('red_grey'),
  },
  {
    label: 'Vermelho → Amarelo → Azul', value: 'red_yellow_blue', id: 'red_yellow_blue', icon: () => preview('red_yellow_blue'),
  },
  {
    label: 'Vermelho → Amarelo → Verde', value: 'red_yellow_green', id: 'red_yellow_green', icon: () => preview('red_yellow_green'),
  },
  {
    label: 'Tons de Azul', value: 'blues', id: 'blues', icon: () => preview('blues'),
  },
  {
    label: 'Tons de Verde', value: 'greens', id: 'greens', icon: () => preview('greens'),
  },
  {
    label: 'Tons de Cinza', value: 'greys', id: 'greys', icon: () => preview('greys'),
  },
  {
    label: 'Tons de Laranja', value: 'oranges', id: 'oranges', icon: () => preview('oranges'),
  },
  {
    label: 'Tons de Roxo', value: 'purples', id: 'purples', icon: () => preview('purples'),
  },
  {
    label: 'Tons de Vermelho', value: 'reds', id: 'reds', icon: () => preview('reds'),
  },
  {
    label: 'Azul → Verde', value: 'blue_green', id: 'blue_green', icon: () => preview('blue_green'),
  },
  {
    label: 'Azul → Roxo', value: 'blue_purple', id: 'blue_purple', icon: () => preview('blue_purple'),
  },
  {
    label: 'Verde → Azul', value: 'green_blue', id: 'green_blue', icon: () => preview('green_blue'),
  },
  {
    label: 'Laranja → Vermelho', value: 'orange_red', id: 'orange_red', icon: () => preview('orange_red'),
  },
  {
    label: 'Roxo → Azul → Verde', value: 'purple_blue_green', id: 'purple_blue_green', icon: () => preview('purple_blue_green'),
  },
  {
    label: 'Roxo → Azul', value: 'purple_blue', id: 'purple_blue', icon: () => preview('purple_blue'),
  },
  {
    label: 'Roxo → Vermelho', value: 'purple_red', id: 'purple_red', icon: () => preview('purple_red'),
  },
  {
    label: 'Vermelho → Roxo', value: 'red_purple', id: 'red_purple', icon: () => preview('red_purple'),
  },
  {
    label: 'Amarelo → Verde → Azul', value: 'yellow_green_blue', id: 'yellow_green_blue', icon: () => preview('yellow_green_blue'),
  },
  {
    label: 'Amarelo → Verde', value: 'yellow_green', id: 'yellow_green', icon: () => preview('yellow_green'),
  },
  {
    label: 'Amarelo → Laranja → Marrom', value: 'yellow_orange_brown', id: 'yellow_orange_brown', icon: () => preview('yellow_orange_brown'),
  },
  {
    label: 'Amarelo → Laranja → Vermelho', value: 'yellow_orange_red', id: 'yellow_orange_red', icon: () => preview('yellow_orange_red'),
  },
]);

export const getMapThemes = () => ([
  {
    label: 'Padrão', value: 'nivo', id: 'nivo', icon: () => preview('nivo'),
  },
  {
    label: 'Spectral', value: 'spectral', id: 'spectral', icon: () => preview('spectral'),
  },
  {
    label: 'Marrom → Verde', value: 'BrBG', id: 'BrBG', icon: () => preview('brown_blueGreen'),
  },
  {
    label: 'Roxo → Verde', value: 'PRGn', id: 'PRGn', icon: () => preview('purpleRed_green'),
  },
  {
    label: 'Rosa → Verde', value: 'PiYG', id: 'PiYG', icon: () => preview('pink_yellowGreen'),
  },
  {
    label: 'Roxo → Laranja', value: 'PuOr', id: 'PuOr', icon: () => preview('purple_orange'),
  },
  {
    label: 'Vermelho → Azul', value: 'RdBu', id: 'RdBu', icon: () => preview('red_blue'),
  },
  {
    label: 'Vermelho → Cinza', value: 'RdGy', id: 'RdGy', icon: () => preview('red_grey'),
  },
  {
    label: 'Vermelho → Amarelo → Azul', value: 'RdYlBu', id: 'RdYlBu', icon: () => preview('red_yellow_blue'),
  },
  {
    label: 'Vermelho → Amarelo → Verde', value: 'RdYlGn', id: 'RdYlGn', icon: () => preview('red_yellow_green'),
  },
  {
    label: 'Tons de Azul', value: 'blues', id: 'blues', icon: () => preview('blues'),
  },
  {
    label: 'Tons de Verde', value: 'greens', id: 'greens', icon: () => preview('greens'),
  },
  {
    label: 'Tons de Cinza', value: 'greys', id: 'greys', icon: () => preview('greys'),
  },
  {
    label: 'Tons de Laranja', value: 'oranges', id: 'oranges', icon: () => preview('oranges'),
  },
  {
    label: 'Tons de Roxo', value: 'purples', id: 'purples', icon: () => preview('purples'),
  },
  {
    label: 'Tons de Vermelho', value: 'reds', id: 'reds', icon: () => preview('reds'),
  },
  {
    label: 'Azul → Verde', value: 'BuGn', id: 'BuGn', icon: () => preview('blue_green'),
  },
  {
    label: 'Azul → Roxo', value: 'BuPu', id: 'BuPu', icon: () => preview('blue_purple'),
  },
  {
    label: 'Verde → Azul', value: 'GnBu', id: 'GnBu', icon: () => preview('green_blue'),
  },
  {
    label: 'Laranja → Vermelho', value: 'OrRd', id: 'OrRd', icon: () => preview('orange_red'),
  },
  {
    label: 'Roxo → Azul → Verde', value: 'PuBuGn', id: 'PuBuGn', icon: () => preview('purple_blue_green'),
  },
  {
    label: 'Roxo → Azul', value: 'PuBu', id: 'PuBu', icon: () => preview('purple_blue'),
  },
  {
    label: 'Roxo → Vermelho', value: 'PuRd', id: 'PuRd', icon: () => preview('purple_red'),
  },
  {
    label: 'Vermelho → Roxo', value: 'RdPu', id: 'RdPu', icon: () => preview('red_purple'),
  },
  {
    label: 'Amarelo → Verde → Azul', value: 'YlGnBu', id: 'YlGnBu', icon: () => preview('yellow_green_blue'),
  },
  {
    label: 'Amarelo → Verde', value: 'YlGn', id: 'YlGn', icon: () => preview('yellow_green'),
  },
  {
    label: 'Amarelo → Laranja → Marrom', value: 'YlOrBr', id: 'YlOrBr', icon: () => preview('yellow_orange_brown'),
  },
  {
    label: 'Amarelo → Laranja → Vermelho', value: 'YlOrRd', id: 'YlOrRd', icon: () => preview('yellow_orange_red'),
  },
]);

export const getColorSchemes = (isMap = false) => {
  const themes = isMap ? getMapThemes() : getOptionsThemes();
  return themes.map((t) => t.value);
};
